import { Grid } from '@chakra-ui/core'
import * as React from 'react'

const GridContainer = ({ children, padding, rowGap = 0, ...rest }: Props) => {
  return (
    <Grid
      templateColumns="repeat(12, 1fr)"
      columnGap={6}
      rowGap={rowGap}
      alignItems="center"
      mx="auto"
      maxWidth="7xl"
      px={padding && 6}
      {...rest}
    >
      {children}
    </Grid>
  )
}

type Props = {
  children: React.ReactNode
  padding?: boolean
  alignItems?: string
  rowGap?: number[] | number | null
  columnGap?: number[] | number | null
  mb?: number[] | number | null
  my?: number[] | number | null
  mt?: number[] | number | null
  pb?: number[] | number | null
  maxWidth?: string
}

export default GridContainer
